import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Crown, Power } from 'lucide-react';
import NotificationBell from '../notifications/NotificationBell';
import SubscriptionSlider from '../billing/SubscriptionSlider';
import oneLineLogo from '../../assets/One-line-logo.png';
import { getCurrentPlatform } from '../../utils/platformUtils';
import api from '../../utils/api';

const Header = ({ activeTab }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [subscription, setSubscription] = useState({ plan: null, status: null });
  const [isSubscriptionSliderOpen, setIsSubscriptionSliderOpen] = useState(false);
  
  const platform = getCurrentPlatform(location.search);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const response = await api.get('/api/subscribe/status');
        setSubscription(response.data);
      } catch (err) {
        console.error('Error fetching subscription:', err);
      }
    };
    
    fetchSubscription();
  }, []);

  const getTitle = () => {
    const titles = {
      dashboard: 'Dashboard',
      carts: 'Abandoned Carts',
      campaigns: 'Email Campaigns',
      customers: 'Customers',
      notifications: 'Notifications',
      coupons: 'Coupons',
      analytics: 'Analytics',
      settings: 'Settings'
    };
    return titles[activeTab] || 'Dashboard';
  };

  const isAuthenticated = !!(sessionStorage.getItem('token') || localStorage.getItem('token'));

  const handleLogout = () => {
    // Clear all authentication and store connection data
    sessionStorage.removeItem('token');
    localStorage.removeItem('token');
    localStorage.removeItem('isConnected');
    localStorage.removeItem('platform');
    localStorage.removeItem('storeUrl');
    localStorage.removeItem('store_connection');
    localStorage.removeItem('woocommerce_connection');
    localStorage.removeItem('shopify_connection');
    window.location.href = '/landing';
  };

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="px-6 py-4 flex justify-between items-center">
        <div className="flex items-center">
          {getTitle() === 'Dashboard' && (
            <img src={oneLineLogo} alt="CartResQ Logo" className="w-36 h-auto mr-3" style={{background: 'transparent'}} />
          )}
          <h2 className="text-xl font-semibold text-gray-900">{getTitle()}</h2>
        </div>
        <div className="flex items-center space-x-4">
          <NotificationBell platform={platform} />
          
          {/* Subscription Status Icon */}
          {subscription.plan && subscription.plan !== 'free' && (
            <button
              onClick={() => setIsSubscriptionSliderOpen(true)}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors group"
              title="View Subscription Status"
            >
              <Crown className="h-5 w-5 text-blue-600 group-hover:text-blue-700" />
            </button>
          )}
          
          <button 
            onClick={() => navigate('/pricing')}
            className="text-blue-600 hover:underline font-medium"
          >
            Pricing
          </button>
          <a 
            href="mailto:support@cartresq.com" 
            className="text-gray-600 hover:underline font-medium"
            title="Contact Support"
          >
            Support
          </a>
          {!isAuthenticated ? (
            <>
              <a href="/login" className="text-gray-700 hover:underline font-medium">Login</a>
              <a href="/register" className="text-gray-700 hover:underline font-medium">Register</a>
            </>
          ) : (
            <button
              onClick={handleLogout}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors group"
              title="Logout"
            >
              <Power className="h-5 w-5 text-red-600 group-hover:text-red-700" />
            </button>
          )}
        </div>
      </div>
      
      {/* Subscription Slider */}
      <SubscriptionSlider 
        isOpen={isSubscriptionSliderOpen}
        onClose={() => setIsSubscriptionSliderOpen(false)}
      />
    </header>
  );
};

export default Header; 